export default __webpack_public_path__ + "static/media/content-arrow.847ccfde.svg";